import { useState } from "react";
import { Box, TextField } from "@mui/material";
import { AdvancedConfirmDialog } from "components";
import { LangConstant } from "const";
import { usePasswordRule, useRole } from "hooks";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { SystemUtils } from "utils";

const ChangePasswordDialog = ({ open, data, onClose, onConfirm }) => {
  const { t: getLabel } = useTranslation();
  const { isServiceAdmin } = useRole();
  const { regexPassword, maxLength, minLength } = usePasswordRule(isServiceAdmin);

  const [password, setPassword] = useState("");

  const handleSubmit = () => {
    if (false === Boolean(data && data.accountId)) {
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
      return;
    }

    onConfirm({
      account_id: data.accountId,
      pin: password,
      onClose: onClose,
    });
  };

  const handlePasswordChange = event => {
    const value = event.target.value;
    if (regexPassword.test(value)) {
      setPassword(value);
    }
  };

  const isDisableSubmit = !regexPassword.test(password) || password.length < minLength || password.length > maxLength;

  return (
    <AdvancedConfirmDialog
      open={open}
      title={getLabel(LangConstant.TXT_CHANGE_PASSWORD)}
      content={
        <Box display="flex" flexDirection="column" gap={2}>
          {getLabel(LangConstant.TXT_CHANGE_PASSWORD_TITLE)}
          <TextField
            label={getLabel(LangConstant.TXT_ENTER_NEW_PASSWORD)}
            fullWidth
            value={password}
            onChange={handlePasswordChange}
            inputProps={{ maxLength: maxLength }}
            name="password"
          />
        </Box>
      }
      submitProps={{
        submitText: getLabel("L_UPDATE"),
        disabled: isDisableSubmit,
        onClick: handleSubmit,
      }}
      cancelProps={{
        onClick: onClose,
      }}
    />
  );
};

ChangePasswordDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ChangePasswordDialog;
